<template>
    <div class="main properties-wrapper">
        <simulation-banner v-if="!scenarioSelected && this.$route.params.simId === undefined"> </simulation-banner>
        <div v-else class="c-cekajici-resene p-page1__wrap">
            <bs-tabs v-if="isCreator || isAdmin" >
                <bs-tab :name="translate('Page1.properties', '')" :selected="true" :customHref="'properties'">
                    <div class="">
                        <div class="">
                            <div class="title">
                                <h1>{{ translate('Page1.properties', '') }}</h1>
                            </div>
                            <page-title :title="translate('Page1.properties')"> </page-title>
                            <properties-form></properties-form>
                        </div>

                    </div>
                </bs-tab>
                <bs-tab v-if="isOwner || isAdmin" :name="translate('Permission.text0')" :customHref="'permissions'">
                    <div class="">
                        <div class="">
                            <div class="title">
                                <h1>{{ translate('Permission.text0') }}</h1>
                            </div>
                            <page-title :title="translate('Permission.text5')"> </page-title>
                            <Permissions> </Permissions>
                            <!--<EventsList :typeOfEventList="'waitingEvents'"></EventsList>-->
                        </div>

                    </div>
                </bs-tab>
                <bs-tab :name="translate('Permission.scenarioData')" :customHref="'data'">
                    <page-title :title="translate('Permission.scenarioData')"> </page-title>
                    <scenario-forms :customHref="'data'"> </scenario-forms>
                </bs-tab>
            </bs-tabs>

            <div v-else class="">
                <div class="">
                    <div class="title">
                        <h1>{{ translate('Permission.text0') }}</h1>
                    </div>
                    <page-title :title="translate('Permission.text5')"> </page-title>
                    <Permissions> </Permissions>
                    <!--<EventsList :typeOfEventList="'waitingEvents'"></EventsList>-->
                </div>

            </div>
        </div>





        <!-- Right menu -->
        <div class="context-menu" id="context-menu" >
        </div>
        <!-- END Right menu -->
        <userBar> </userBar>

    </div>
</template>

<script>
    import bsTab from '@/components/bsTab.vue';
    import bsTabs from '@/components/bsTabs.vue';
    import Permissions from "@/components/Permissions.vue";
    import userBar from '@/components/userBar.vue';
    import pageTitle from "../components/pageTitle";
    import PropertiesForm from "../components/propertiesForm";
    import simulationBanner from "../components/simulationBanner";
    import ScenarioForms from "../components/ScenarioForms";
    import loadSimId from "../mixins/loadSimId";

    export default {
        name: "page1",
        data: function() {
            return {
                data: [],
                simId: null,
            }
        },
        mixins: [loadSimId],
        computed: {
            scenarioSelected(){
                return this.$store.state.scenarioSelected;
            },
            ownerUserId() {
                let prop = this.data.find(prop => prop.property === "ownerUserId");
                if (prop && prop.hasOwnProperty("value")) return prop.value;
                else return undefined;
            },
            isCreator() {
                return this.$store.state.auth.user.creator || false;
            },
            isAdmin() {
                return this.$store.state.auth.user.isAdmin || false;
            },
            isOwner() {
                return this.$store.state.auth.user.id === this.ownerUserId;
            }
        },
        methods: {
            async getSimulationProperties(){
                const simId = this.simId;
                return this.$store.dispatch('callApi', {
                    name: 'getSimulationProperties',
                    payload: {simId}
                });
            },
            async loadSimulationProperties(){
                const data = await this.getSimulationProperties();
                this.$set(this, 'data', data);
            }
        },
        components: {
            PropertiesForm,
            Permissions,
            bsTab,
            bsTabs,
            userBar,
            pageTitle,
            simulationBanner,
            ScenarioForms
        },
        async created(){
            this.loadSimId();
            await this.loadSimulationProperties();

        }
    }
</script>

<style lang="less">

    .properties-wrapper {
        padding: 20px;
    }
    .p-page1 {
        &__wrap {

        }
        &__row-item {
            height: calc(~'50vh - 85px');
            margin: 5px 10px;
        }
    }
</style>
